import { toast } from 'react-toastify';
import { toastError } from '../../../../utils';
import { callApi } from '../../../../apiCaller';
import {
     API_SYSTEM_ADMIN_DUPLICATE_TEST,
     API_SYSTEM_ADMIN_TEST,
     API_SYSTEM_ADMIN_TESTS,
     API_SYSTEM_ADMIN_TEST_DELETE_CHECKING,
     POPUP_TYPE,
     SYSTEM_ADMIN_PATH,
     TEST_ADMIN_OBJECT,
} from '../../../../constants';
import {
     setIsWaiting,
     setIsLoading,
     setRemoveLoading,
     setShowRemovePopup,
     setShowPopup,
     setShowPopupDetail,
     setShowRelatedObjectWarningPopup,
     setCurrentTab,
} from '../../../../actions/general';
import { setAdminDataAddProduct } from '../GlobalStates/DataAddProduct/actions';
import { setAdminTestDetails } from './Test/actions';

export const ADD_ADMIN_TEST = 'addAdminTest';
export const ADD_ADMIN_TESTS = 'addAdminTests';
export const UPDATE_ADMIN_TEST = 'updateAdminTest';
export const DELETE_ADMIN_TEST = 'deleteAdminTest';

const addAdminTest = (test) => {
     return {
          type: ADD_ADMIN_TEST,
          payload: test,
     };
};

export const addAdminTests = (tests) => {
     return {
          type: ADD_ADMIN_TESTS,
          payload: tests,
     };
};

export const updateAdminTest = (test) => {
     return {
          type: UPDATE_ADMIN_TEST,
          payload: test,
     };
};

const deleteAdminTest = (testId) => {
     return {
          type: DELETE_ADMIN_TEST,
          payload: testId,
     };
};

export const deleteTestFromDataAddProduct = (id) => (dispatch, getState) => {
     const dataAddProduct = getState().admin.dataAddProduct;

     if (dataAddProduct !== null) {
          const newTests = dataAddProduct.tests.filter((test) => test.id !== id);
          dataAddProduct.tests = newTests;
          dispatch(setAdminDataAddProduct(dataAddProduct));
     }
};

export const fetchAdminTestListRequest = () => (dispatch) => {
     dispatch(setIsLoading(true));

     callApi(API_SYSTEM_ADMIN_TESTS, 'GET')
          .then((response) => {
               if (response.status !== 200) {
                    toastError(response);
                    return;
               }

               dispatch(addAdminTests(response.data));
          })
          .finally(() => {
               dispatch(setIsLoading(false));
          });
};

export const addAdminTestRequest = (test, navigate) => (dispatch) => {
     dispatch(setIsWaiting(true));

     callApi(API_SYSTEM_ADMIN_TESTS, 'POST', test)
          .then((response) => {
               if (response.status !== 200) {
                    toastError(response);
                    return;
               }

               const newTest = response.data;

               dispatch(addAdminTest(newTest));
               dispatch(addTestToDataAddProduct(newTest));

               dispatch(setShowPopup());
               navigate(SYSTEM_ADMIN_PATH.TESTS_DETAIL.replace(':id', response.data.id));
          })
          .finally(() => {
               dispatch(setIsWaiting(false));
          });
};

export const duplicateTestRequest = (testId) => (dispatch) => {
     dispatch(setIsWaiting(true));
     callApi(API_SYSTEM_ADMIN_DUPLICATE_TEST, 'POST', { testId })
          .then((response) => {
               if (response.status !== 200) {
                    toastError(response);
                    return;
               }

               const newTest = response.data;

               dispatch(addAdminTest(newTest));
               dispatch(addTestToDataAddProduct(newTest));

               toast.success('Clone Successfully');
          })
          .finally(() => {
               dispatch(setIsWaiting(false));
          });
};

export const updateAdminTestRequest = (testId, test) => (dispatch, getState) => {
     const testDetails = getState().admin.testDetails;
     const testList = getState().admin.tests;
     dispatch(setIsWaiting(true));
     callApi(API_SYSTEM_ADMIN_TEST.replace(':id', testId), 'PUT', test)
          .then((response) => {
               if (response.status !== 200) {
                    toastError(response);
                    return;
               }

               const newTest = response.data;

               const newTestDetails = {
                    ...testDetails,
                    ...newTest,
               };
               dispatch(setAdminTestDetails(newTestDetails));

               if (testList.length) {
                    dispatch(updateAdminTest(newTest));
               }

               dispatch(setShowPopupDetail(null));
               dispatch(updateTestToDataAddProduct(newTest));
               toast.success('Update Successfully');
          })
          .finally(() => {
               dispatch(setIsWaiting(false));
          });
};

export const checkRemoveAdminTestRequest = (testId) => (dispatch) => {
     callApi(`${API_SYSTEM_ADMIN_TEST_DELETE_CHECKING.replace(':id', testId)}`, 'GET').then((response) => {
          if (response.status === 200 && response.data.canDelete) {
               dispatch(setCurrentTab(TEST_ADMIN_OBJECT));
               dispatch(setShowRemovePopup(testId));
               return;
          }

          if (response.data.isUsedForProducts) {
               dispatch(setShowRelatedObjectWarningPopup(POPUP_TYPE.WARNING_RELATED, response.data.message));
          } else {
               toastError(response);
          }
     });
};

export const proceedRemoveAdminTestRequest =
     (testId, navigate = null) =>
     (dispatch) => {
          dispatch(setRemoveLoading(true));

          callApi(API_SYSTEM_ADMIN_TEST.replace(':id', testId), 'DELETE')
               .then((response) => {
                    if (response.status !== 200) {
                         toastError(response);
                         return;
                    }

                    dispatch(deleteAdminTest(testId));
                    dispatch(deleteTestFromDataAddProduct(testId));
                    if (navigate) {
                         navigate(SYSTEM_ADMIN_PATH.TESTS, { replace: true });
                    }
                    toast.success('Delete Successfully');
               })
               .catch((response) => {
                    toastError(response);
               })
               .finally(() => {
                    dispatch(setRemoveLoading(false));
                    dispatch(setCurrentTab(null));
                    dispatch(setShowRemovePopup(null));
               });
     };

export const checkCanDeleteTestRequest = (testId, nextDispatch) => (dispatch) => {
     const { checkedValue, setFieldValue, setStatusLoading } = nextDispatch;

     if (!testId || checkedValue) {
          setFieldValue('status', checkedValue);
          return;
     }

     // Check if can turn off status
     setStatusLoading(true);

     callApi(`${API_SYSTEM_ADMIN_TEST_DELETE_CHECKING.replace(':id', testId)}`, 'GET')
          .then((response) => {
               if (response.status === 200 && response.data.canDelete) {
                    setFieldValue('status', checkedValue);
                    return;
               }

               if (response.data.isUsedForProducts) {
                    dispatch(setShowRelatedObjectWarningPopup(POPUP_TYPE.WARNING_RELATED, response.data.message));
               } else {
                    toastError(response);
               }
          })
          .finally(() => {
               setStatusLoading(false);
          });
};

const addTestToDataAddProduct = (test) => (dispatch, getState) => {
     const dataAddProduct = getState().admin.dataAddProduct;

     if (!dataAddProduct || !dataAddProduct.tests || !dataAddProduct.tests.length) {
          return;
     }

     const dataAddProductList = dataAddProduct;
     const dataTestList = [...dataAddProductList.tests];

     dataTestList.push(test);
     dataAddProductList.tests = dataTestList;

     dispatch(setAdminDataAddProduct(dataAddProductList));
};

const updateTestToDataAddProduct = (test) => (dispatch, getState) => {
     const dataAddProduct = getState().admin.dataAddProduct;

     if (!dataAddProduct || !dataAddProduct.tests || !dataAddProduct.tests.length) {
          return;
     }

     const newDataTests = dataAddProduct.tests.map((testItem) => {
          if (testItem.id === test.id) {
               return {
                    id: test.id,
                    name: test.name,
               };
          }

          return {
               id: testItem.id,
               name: testItem.name,
          };
     });

     dataAddProduct.tests = newDataTests;
     dispatch(setAdminDataAddProduct(dataAddProduct));
};
